export default {
    methods: {
        getIconByType(type) {
            switch (type) {
                case 'third':
                case 'client':
                case 'prospect':
                case 'supplier':
                    return 'nav-company';

                case 'people':
                case 'thirdcontact':
                    return 'nav-contact';

                case 'opportunity':
                    return 'nav-opportunity';

                case 'order':
                case 'model':
                case 'invoice':
                case 'estimate':
                case 'delivery':
                case 'proforma':
                case 'creditnote':
                    return 'nav-billing';

                case 'purOrder':
                case 'purDelivery':
                case 'purInvoice':
                case 'purCreditNote':
                    return 'nav-purchases';

                case 'project':
                    return 'nav-projects';

                case 'task':
                    return 'task';

                case 'event':
                case 'agendaEventLink':
                    return 'calendar';

                case 'email':
                case 'nylasemailqueue':
                case 'nylasemaillinked':
                    return 'email';

                case 'phonecall':
                    return 'phone';

                case 'annotation':
                    return 'comment';
            }
        },
    },
};
